module.exports = __webpack_public_path__ + "media/images/user/audio_icon-76e5a520a45d9ec57bb7c796a5b943a3.png";